import { gql } from '@apollo/client';

export const STAKING_SCREEN_GET_DAILY_STAKING_ENROLLMENTS = gql`
	query StakingScreen_GetDailyStakingEnrollments($input: GetDailyStakingEnrollmentsInput!) {
		dailyStakingEnrollments(input: $input) {
			success
			errorMessage
			data {
				date
				stakingBalances {
					ticker
					overallCount
					totalOverallBalance
					totalOverallValue
				}
				stakingAmounts {
					productType
					stakeStakingAmounts {
						count
						ticker
						principleAmount
					}
					unstakeStakingAmounts {
						count
						ticker
						itcFeeAmount
						principleAmount
						rewardAmount
						totalAmount
					}
				}
			}
		}
	}
`;
